package com.milta.feature.settings.presentation

sealed interface AdminSettingsIntent {
    data object Load : AdminSettingsIntent

    /** Applies immediately (no separate confirm step), same convention as [WebSettingsIntent.SelectLanguage]. */
    data class SelectLanguage(val tag: String) : AdminSettingsIntent
}
